<div class="doc-form-wrapper">
  <!-- form -->
  <form [formGroup]="form" class="doc-form" *ngIf="form">
    <!-- name -->
    <app-form-input-text [field]="'name'" [formControl]="f['name']" formControlName="name"></app-form-input-text>
    <!-- description -->
    <app-form-input-editor [field]="'description'" [formControl]="f['description']"
      [formControlName]="'description'" [height]="'10vh'"></app-form-input-editor>
    <!-- file -->
    <app-form-input-file [field]="'file'" [formControl]="f['document']" formControlName="document" [ext]="'pdf'"></app-form-input-file>
    <!-- buttons -->
    <div class="buttons">
      <p-button [label]="'button.cancel' | translate" severity="secondary" (click)="cancel()"/>
      <p-button [label]="'button.save' | translate" severity="contrast" (click)="save()"/>
    </div>
  </form>
</div>
    